<template>
    <div class="labeled-value">
        <DeliverableLabel v-if="label" :color="labelColor" :label="label" />
        <div class="labeled-value__text" @click="onClick">
            <span
                class="labeled-value__text--value"
                :class="{ 'labeled-value__text--value-whitespace': isValueWhitespace }"
            >
                {{ modelValue }}
            </span>
            <div class="labeled-value__icons-container">
                <slot name="icons" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import DeliverableLabel from "@/components/Campaign/DeliverableLabel.vue";
import type { PropType } from "vue";

export default {
    name: "LabeledValue",
    components: { DeliverableLabel },
    props: {
        label: {
            type: String
        },
        labelColor: {
            type: String as PropType<"default" | "primary">,
            default: "default"
        },
        modelValue: {
            type: String,
            required: true
        }
    },

    emits: ["click"],

    methods: {
        isValueWhitespace() {
            return /^\s$/.test(this.modelValue);
        },

        onClick() {
            this.$emit("click");
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.labeled-value {
    display: flex;
    align-items: center;
    min-width: 0;
    padding: 0 0 0 10px;
    width: 100%;

    &__icons-container {
        display: none;
    }

    &__text {
        flex: 1 0;
        display: flex;
        overflow: hidden;
        padding: 0 5px;
        align-items: center;
        cursor: pointer;

        &--value {
            flex: 1 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &-whitespace:before,
            &:empty:before {
                content: "\200b";
            }
        }

        &:hover {
            .labeled-value__icons-container {
                color: $cmp-dark-font-color;
                display: block;
            }
        }
    }
}
</style>
